module.exports = __webpack_public_path__ + "img/header-diamondJewelryEarrings.d1cc67e.jpg";